<template>
    <v-container fluid>
        <v-form>
            <v-card>
                <v-card-title>
                    <v-container>
                        <v-row>
                            <v-col :cols="12">{{ title }}</v-col>
                        </v-row>

                        <parameters :parameters="parameters" />

                        <v-row>
                            <v-col>
                                <v-btn v-on:click="runQuery" :disabled="!isFormValid">Build Report</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-title>

                <v-card-text>
                    <report-table :items="items" :headers="headers" :query-loading="queryLoading" :title="title" />
                </v-card-text>
            </v-card>
        </v-form>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import errorUtility from '../services/errorUtility'
    import { DateTime } from 'luxon'

    export default {
        components: {
            reportTable: () => import('../reports/ReportTable'),
            parameters: () => import('../reports/Parameters')
        },

        data() {
            return {
                queryLoading: false,

                headers: [
                    { text: "Bqual Number", value: "bqualNumber" },
                    { text: "Region", value: "region" },
                    { text: "Load Moved On", value: "loadMovedOn", format: this.formatDate },
                    { text: "Harvested On", value: "harvestedOn", format: this.formatDate },
                    { text: "Harvest Weight (kg)", value: "harvestWeightInKilograms" },
                    { text: "Total Weight from Site (kg)", value: "totalWeightFromSite" },
                    { text: "Number Of Frames", value: "numberOfFrames" },
                    { text: "Frame Type", value: "frameType", format: this.formatEnum },
                    { text: "Normalized Weight Per Frame", value: "normalizedWeightPerFrame" }
                ],
                items: [],
                parameters: [
                    { component: () => import('./DateParameter'), fields: { name: "From", field: "from", value: this.getFilterFromDate() } },
                    { component: () => import('./DateParameter'), fields: { name: "To", field: "to", value: this.getFilterToDate() } },
                    { component: () => import('./AutocompleteParameter'), fields: { name: "Region Type", field: "regionTypeId", value: null, apiMethod: 'RegionTypes' } }
                ],
                title: "Honey Yield Report",

                isFormValid: false
            }
        },

        async mounted() {
            var response = await axios.get('api/RegionTypes');
            var regionTypes = response.data.items;
            var region = regionTypes.find(e => e.name === "Region");
            if (region !== null && typeof region !== "undefined") {
                this.parameters[2].fields.value = region.id;
            }
        },

        methods: {
            async runQuery() {
                this.queryLoading = true;
                try {
                    var params = {};
                    this.parameters.forEach(e => params[e.fields.field] = e.fields.value);
                    var response = await axios.get('/api/HoneyYieldReport', { params });
                    this.items = response.data;
                }
                catch (error) {
                    errorUtility.handleServerError(error);
                }
                finally {
                    this.queryLoading = false;
                }
            },
            getFilterFromDate() {
                var currentDate = new Date();
                currentDate.setMonth(currentDate.getMonth() - 1);
                return currentDate.toISOString().slice(0, 10);
            },
            getFilterToDate() {
                return DateTime.local().toISODate();
            }
        },
        watch: {
            parameters: {
                deep: true,
                handler() {
                    if (this.parameters.every(e => e.fields.value != null)) {
                        this.isFormValid = true;
                    }
                }
            }
        }
    }
</script>
